patternIsRegExp